/**
 * Maps internal states to states the brand cares about regarding fulfillment.
 */
export enum BrandOrderFulfillmentState {
  /**
   * The brand has not yet accepted the order.
   */
  NEW = 'NEW',
  /**
   * The brand has accepted the order, but has not added shipments to it.
   */
  UNFULFILLED = 'UNFULFILLED',
  /**
   * The brand has added shipments to the order.
   */
  FULFILLED = 'FULFILLED',
  /**
   * The order is canceled, and the brand was contacted about the order.
   */
  CANCELED = 'CANCELED',
}
